function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { useContext } from 'react';
import { withContext } from 'with-context';
export default function createContextHelpers(Context, name) {
    var capitalizedName = name.charAt(0).toUpperCase() + name.slice(1);
    var Provider = Context.Provider;
    function useMethod() {
        return useContext(Context);
    }
    var _obj;
    return _obj = {}, _define_property(_obj, "".concat(name, "Context"), Context), _define_property(_obj, "".concat(capitalizedName, "Provider"), Provider), _define_property(_obj, "use".concat(capitalizedName), useMethod), _define_property(_obj, "with".concat(capitalizedName), withContext(Context, name)), _obj;
}
